import type { FC } from 'react';

export interface MessageTextProps {
  text?: string | null;
}

export const MessageText: FC<MessageTextProps> = ({ text }) => {
  return (
    <div className="text-sm whitespace-pre-wrap break-words font-normal">
      {text}
    </div>
  );
};
